export const ToastEvent = {
  DEFAULT: 'default',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  PROCESSING: 'processing',
} as const

export type ToastEvent = (typeof ToastEvent)[keyof typeof ToastEvent]

export type ToastAction = {
  label: string
  onClick: () => void
}

export type ToastProps = {
  variant: ToastEvent
  meta: { title: string; desc?: string }
  actions?: ToastAction[]
}
